<div class="mt-auto p-6 pt-0 text-center dark:text-white-dark ltr:sm:text-left rtl:sm:text-right">© {{ currYear }}. {{ "Techne Logus All rights reserved." | translate }}</div>
